import React, { useContext, useState } from "react";
import {
  DataContextReclamo,
  DataProvier,
} from "../../context/DataContextReclamo";
import DivRow from "../controls/DivRow";

const Step4 = () => {
  const { tramite, setTramite, changeHandler } = useContext(DataContextReclamo);
  const closeModal = () => setTramite({ ...tramite, showDialogPagoSuccess: false });

  const closeModalFinish = () =>
    setTramite({ ...tramite, showDialogFinish: false });

  const closeModalFaild = () => setTramite({ ...tramite, faild: false });

  const openModal = () => setTramite({ ...tramite, showModal: true });

  const getProcedure = () => {
    let result = document.querySelector("form").reportValidity();

    if (!result) return;

    openModal();
  };

  return (
    <div className="step">
      <DivRow width="100%">
        <p className="p_temrinosNR">
          Al hacer click en el botón "Notificar Siniestro", yo hago constar que
          las declaraciones contenidas en este formato son correctas, verídicas
          y que cualquier declaración falsa o inexacta anula este reclamo y la
          póliza afectada.
        </p>
        <p className="p_temrinosNR">
          Asímismo estoy enterado de que la presentación de esta declaración no
          significa reconocimiento de los derechos que eventualmente ampara la
          póliza, ni aceptación de hechos en que pueda fundarse este reclamo y
          que la decisión de La Compañía será notificada por cualquier medio
          (digital o fisico) después del análisis del reclamo.
        </p>
        <br/>
        <div>
          <input type="checkbox" className="checkNR" name="acceptaTerminos"  id="acceptaTerminos" required />
         <a rel='noreferrer' href="https://www.lafise.com/terminos-y-condiciones-de-uso" target='_blank' className="teminosycondiciones">Acepto términos y condiciones de uso</a>
          
          
        </div>
      </DivRow>
    </div>
  );
};

export default Step4;
